import React, { useState } from 'react'
import './Stars.css'
import axios from 'axios'
import endpoints from '../endpoints.json'
import Popup from './Popup'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'preact/hooks'

const Stars = ({
  query,
  answer,
  id,
  userId,
  userMail,
  statsFunction,
  searchContext,
  graphConfig,
  index_dep,
  hasSources
}) => {
  const navigate = useNavigate()
  const [hoverRating, setHoverRating] = useState(0)
  const [clickedRating, setClickedRating] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [SilentPressed, setSilentPressed] = useState(false)
  const [PinocchioPressed, setPinocchioPressed] = useState(false)
  // Remove the unused variable 'setComment'

  const handleMouseOver = (idx) => {
    setHoverRating(idx)
    console.log(hasSources)
  }

  const log = async ({
    rating = hoverRating,
    lying = PinocchioPressed,
    dont_know = SilentPressed,
    comment = ''
  } = {}) => {
    try {
      const response = await window.PDR.api.post(`${endpoints[window.location.host]}/log`, {
        query: query,
        answer: answer,
        rating: rating,
        id: id,
        lying: lying,
        dont_know: dont_know,
        comment: comment,
        userId: userId,
        userMail: userMail
      })
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClick = async (index) => {
    setClickedRating(index)
    setHoverRating(index)
    log({ rating: index })
  }

  const handlePinocchioClick = async () => {
    log({ lying: !PinocchioPressed })
    setPinocchioPressed(!PinocchioPressed)
  }

  const togglePopup = () => {
    setIsOpen(!isOpen)
  }

  const handleSilentClick = async () => {
    log({ dont_know: !SilentPressed })
    setSilentPressed(!SilentPressed)
  }

  const handleMouseOut = () => {
    setHoverRating(clickedRating)
  }

  function searchSQL(answer) {
    const regex = /```sql\n([\s\S]+?)\n```/
    const found = answer.match(regex)
    if (found && found.length > 1) {
      return found[1]
    } else {
      console.error('SQL query not found')
      return ''
    }
  }

  useEffect(() => {
    console.log('Graph config:', graphConfig)
  }, [])

  const handleDashboard = () => {
    //console.log(answer)
    console.log(graphConfig)
    const sql = searchSQL(answer)
    navigate(`/dashboards`, {
      state: { sql, graphConfig, userId, userMail, id: null }
    })
  }

  return (
    <div className="star-rating">
      {searchContext === 'sql' && Object.keys(graphConfig).length > 0 && (
        <div className="dashboard-icon" onClick={handleDashboard}>
          <one-ux-icon
            icon="menu-user-insights"
            style="color: var(--one-ux-palette--violet-500)"
            set="platform-center"></one-ux-icon>
          <div className="tooltip">Convert to dashboard graph</div>
        </div>
      )}
      <Popup isOpen={isOpen} onClose={togglePopup} log={log}></Popup>
      {hasSources && (
        <div className="stats" onClick={statsFunction}>
          <img className="card-icon-results" src="chart-mixed.svg" alt="Info-Card" />
          <div className="tooltip">Go to the statistics page for this answer</div>
        </div>
      )}
      <div className="comment" onClick={togglePopup}>
        💬
        <div className="tooltip">Add a comment.</div>
      </div>
      <div className={`silent ${!SilentPressed ? 'pressed-emoji' : ''}`} onClick={handleSilentClick}>
        🤐
        <div className="tooltip">
          Click if Stratsys AI responds with "I don't know" when it should provide an answer.
        </div>
      </div>
      <div className={`pinocchio ${!PinocchioPressed ? 'pressed-emoji' : ''}`} onClick={handlePinocchioClick}>
        🤥
        <div className="tooltip">Click if Stratsys AI is lying</div>
      </div>

      {[...Array(5)].map((star, index) => {
        index += 1
        return (
          <button
            type="button"
            key={index}
            className={index <= hoverRating ? 'on' : 'off'}
            onMouseOver={() => handleMouseOver(index)}
            onMouseOut={handleMouseOut}
            onClick={() => handleClick(index)}>
            <span className="star">&#9733;</span>
          </button>
        )
      })}
    </div>
  )
}

export default Stars
